
import { z } from "zod";

export const PandadocDocumentHistoryFieldValues = ["status", "sentAt", "lastViewedAt"] as const;
export const PandadocDocumentHistoryFieldSchema = z.enum(PandadocDocumentHistoryFieldValues);
export const PandadocDocumentHistoryField = PandadocDocumentHistoryFieldSchema.enum;
export type PandadocDocumentHistoryField = (typeof PandadocDocumentHistoryFieldValues)[number];
